import { render, staticRenderFns } from "./AccountsPayableTranshipment.vue?vue&type=template&id=14c1157f&scoped=true"
import script from "./AccountsPayableTranshipment.vue?vue&type=script&lang=js"
export * from "./AccountsPayableTranshipment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c1157f",
  null
  
)

export default component.exports